export enum BankModalType{
    store = "store",
    hub = "hub",
}